const notesDefault = {
    notes: [
      
    ]
};

export default function notesReducer (state = notesDefault, action) {
    switch (action.type) {
       case 'ADD_NOTE':
           console.log('created note', action.note)
           return state

       case 'ADD_NOTE_ERROR':
           console.log('add note error', action.err)
           return state

       case 'REMOVE_NOTE':
           console.log('deleted note', action.id)
           return state

        case 'REMOVE_NOTE_ERROR':
           console.log('delete note error', action.err)
           return state

       case 'EDIT_NOTE':
           console.log('edited note', action.id)
           return state

        case 'EDIT_NOTE_ERROR':
           console.log('edit note error', action.err)
           return state

       default:
            return state;
    }
}